// extracted by mini-css-extract-plugin
module.exports = {"shadowBottom":"DeliveryModalLegacy_shadowBottom__N6jSy"};